import { render } from "./APagination.vue?vue&type=template&id=d3dc5932"
import script from "./APagination.vue?vue&type=script&lang=js"
export * from "./APagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__